import { StatusCell } from '@/list/components/cells/status-cell';
import * as lc from '../license-content-styles';

const STR_LICENSE = 'STR License';
const RENEWAL_SUBMITTED_TEXT = 'Renewal Submitted';

type TLicenseHeaderTitleProps = {
  isLicenseApplication: boolean;
  renewalsAvailable: boolean;
  status: string;
  text?: string;
};

export function LicenseHeaderTitle(props: TLicenseHeaderTitleProps) {
  return (
    <lc.TitleWrapper>
      <p>{props.text || STR_LICENSE}</p>

      <div className="flex gap-4">
        {/* Renewal Application Status Cell */}
        {props.renewalsAvailable && (
          // @ts-expect-error JSX file
          <StatusCell
            ariaLabel="Renewal status"
            value="submitted"
            valueFormatted={RENEWAL_SUBMITTED_TEXT}
          />
        )}

        {/* License Status Cell */}
        {/* @ts-expect-error JSX file */}
        <StatusCell
          ariaLabel={`${props.isLicenseApplication ? 'Application' : 'License'} status`}
          value={props.status}
        />
      </div>
    </lc.TitleWrapper>
  );
}
